<template>
  <div class="commission-list mt-5 mb-5">
    <div class="site-wrapper">
      <div class="main-wrapper">
        <div class="container-fluild mb-5">
          <div class="title w-100 d-flex justify-content-between">
            <span>Nguồn thu</span>
            <span class="back-btn btn-primary btn-sm" @click="$router.go(-1)">
              <b-icon-arrow90deg-left />
              <span class="ml-2">Quay lại</span>
            </span>
          </div>
          <div class="container mt-5 mb-5" v-loading="loading" style="min-height: 100%">
            <b-card
              v-for="item in commissions"
              :key="item._id"
              class="commission-card"
              border-variant="primary"
            >
              <div
                class="h-100 w-100"
              >
                <div class="inner d-flex align-content-center align-items-center">
                  <div class="row">
                    <div class="col col-9 d-flex align-items-center">
                      <div class="img-box left h-100">
                        <img :src="item.course.thumbnail_url | getMediaUrl" alt="Learnova">
                      </div>
                      <div class="right h-100 w-100 d-flex align-items-center flex-wrap" style="padding: 14px">
                        <div class="order-id">
                          <span class="pr-1">
                            <b-icon-file-earmark-text />
                          </span>
                          <span class="key-title">Mã đơn hàng: </span>
                          <span>
                            {{ get(item, 'order.code') }}
                          </span>
                        </div>
                        <div class="course-name w-100">
                          <span class="pr-1">
                            <b-icon-award />
                          </span>
                          <span class="key-title">Khoá học: </span>
                          <span>
                            {{ get(item, 'product.name') }}
                          </span>
                        </div>
                        <div class="created-at w-100 pt-1">
                          <span class="pr-1">
                            <b-icon-clock />
                          </span>
                          <span class="key-title">Thời gian: </span>
                          <span>
                            {{ item.created_at | getDate }}
                          </span>
                        </div>
                        <div class="order pt-1">
                          <span class="pr-1">
                            <b-icon-credit-card2-back />
                          </span>
                          <span class="key-title">Hoa hồng: </span>
                          <span class="total" :style="item.commission < 0 ? 'color: rgb(255, 72, 116)': ''">
                            {{ item.commission | vnd }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.order && item.order.user" class="col col-3 d-flex align-content-center flex-wrap">
                      <div class="w-100 d-flex justify-content-center">
                        <img :src="get(item, 'order.user.profile.pic') | getMediaUrl" alt="" style="width: 56px; height: 56px; border-radius: 50%">
                      </div>
                      <div class="w-100 text-center">
                        {{ get(item, 'order.user.profile.fullname') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>

            <Pagination
              v-if="commissionsPaginate && commissionsPaginate.total > 0"
              class="mt-2"
              :page.sync="page"
              :limit.sync="limit"
              :total.sync="commissionsPaginate.total"
              @update:page="getCommissions"
              @update:limit="getCommissions"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },

  computed: {
    ...mapGetters({
      commissions: 'commissions',
      commissionsPaginate: 'commissionsPaginate'
    })
  },

  data() {
    return {
      loading: false,
      page: 1,
      limit: 10
    }
  },

  watch: {
    $route: {
      handler() {
        this.init()
      },
      immediate: true
    }
  },

  methods: {
    init() {
      this.getCommissions()
    },

    async getCommissions(data) {
      this.loading = true

      try {
        await this.$store.dispatch('course/GetCommissions', {
          page: this.page,
          limit: this.limit
        })
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    get(obj, key) {
      return _.get(obj, key) || ''
    }
  }
}
</script>

<style lang="scss">
.commission-list {
  .title {
    font-size: 24px;
    font-weight: bold;
    font-family: Inter;
  }

  .key-title {
    width: 120px;
    display: inline-block;
    color: #848B96;
  }

  .back-btn {
    font-size: 14px;
    cursor: pointer;
  }

  .commission-card {
    position: relative;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.12);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);

    .card-body {
      padding: 0;
    }

    .img-box {
      width: 320px;
      display: table;
    }

    .inner {
      height: 100%;
      width: 100%;
      color: #403B36;
      background-color: #ffffff;
      border-radius: 10px;

      img {
        max-height: 180px;
        max-width: 320px;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }

      .total {
        color: #4477DB;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>
